import {InclusionDateType, PeriodType} from 'modules/decisionsNext/api/types';
import {
  DateRangeFieldValue,
  DateRangeValueProps,
} from 'features/GlobalFilterProvider/filters/period/DateRangeItem/types';

import {useIsDownMd} from 'utils/hooks/useMediaQuery';

import {RadioGroup} from 'components/RadioGroup';

const dateTypeOptions = [
  {
    label: 'Effective date',
    value: InclusionDateType.Inception,
  },
  {
    label: 'Expiration date',
    value: InclusionDateType.Expiration,
  },
  {
    label: 'Inforce date',
    value: PeriodType.InForce,
  },
  {
    label: 'Billing transaction date',
    value: InclusionDateType.Transaction,
  },
];

export const DateTypeRadioGroup = ({value, updateValue}: DateRangeValueProps) => {
  const isDownMd = useIsDownMd();

  const dateTypeValue = value.type === PeriodType.InForce ? PeriodType.InForce : value.inclusionDateType;

  return (
    <RadioGroup
      data-testId='filters-date-type-radio-group'
      row={!isDownMd}
      options={dateTypeOptions}
      value={dateTypeValue}
      onChange={(_, type) => {
        if (type === PeriodType.InForce) {
          return updateValue({
            type,
            timestamp: undefined,
            inForceToday: true,
            additionalPeriod: null,
          });
        }

        updateValue({
          inclusionDateType: type as InclusionDateType,
          type: (value.type !== PeriodType.InForce && value.type) || PeriodType.Ytd,
          additionalPeriod: type !== InclusionDateType.Transaction ? value.additionalPeriod : undefined,
        } satisfies DateRangeFieldValue);
      }}
    />
  );
};
